import React from "react";
import Typography from "@/components/common/typography";
import CarDetailingPackageSelector from "./carDetailingPackageSelector";
import CarDetailingPackageAddonsSection from "./carDetailingPackageAddonsSection";
import {
  BlockCarDetailingPackageHighlight,
  BlockServiceAddonHighlight,
} from "@/types/schema";
import ContentWrapper from "@/components/common/wrappers/contentWrapper";
import { Heading } from "@/components/common/typography/Heading";
import { DirectusFile } from "@directus/sdk";
import Image from "next/image";
import {
  AddonCategory,
  fetchAddonByCategory,
} from "@/services/addons/addons.query";
import {
  CarDetailingAddOns,
  CarDetailingAddOnsProps,
} from "../CarDetailingAddOns";

interface CarDetailingPackageBlockProps {
  isInteriorCarDetailing?: boolean;
  highlightData: BlockCarDetailingPackageHighlight;
  showAddons?: boolean;
  addons?: CarDetailingAddOnsProps;
  isCa: boolean;
  paymentFooter?: boolean;
  paymentFooterImages?: DirectusFile[];
  containerClassName?: string;
  showDescription?: boolean;
  noWrapTabs?: boolean;
  showTitle?: boolean;
  blue?: boolean;
}
const CarDetailingPackageBlock: React.FC<
  CarDetailingPackageBlockProps
> = async ({
  containerClassName,
  isInteriorCarDetailing = false,
  highlightData,
  paymentFooter = false,
  paymentFooterImages,
  showDescription = true,
  noWrapTabs = false,
  addons,
  showTitle = true,
  showAddons = true,
  isCa,
  blue = false,
}) => {
  return (
    <section
      className={`${containerClassName} bg-bgColor mt-sections-mobile-70 `}
    >
      <ContentWrapper>
        <section className=" mt-[4.375rem] sm:mt-[7.5rem] flex flex-col xl:max-w-1/2">
          {showTitle && (
            <Heading
              as="h2"
              size="h2"
              weight={400}
              color="black"
              className="mb-9"
            >
              {highlightData.title}
            </Heading>
          )}

          {showDescription && (
            <Typography
              as="p"
              size="body1"
              weight={400}
              color="darkGray"
              className="mb-9"
            >
              {highlightData.description}
            </Typography>
          )}
        </section>
        <CarDetailingPackageSelector
          blue={blue}
          noWrapTabs={noWrapTabs}
          initialView={isInteriorCarDetailing ? "interior" : "full_detail"}
          highlightData={highlightData}
          isCa={isCa}
        />
        {addons && showAddons && (
          <CarDetailingAddOns
            title="Car Detailing"
            interiorAddons={addons.interiorAddons}
            exteriorAddons={addons.exteriorAddons}
          />
        )}

        {paymentFooter && paymentFooterImages && (
          <footer className="bg-white rounded-card w-full mt-5 p-30px gap-y-15px flex lg:flex-row flex-col justify-between">
            <Heading size="h6" as="p">
              We Accept the Following Payment Methods
            </Heading>

            <div className="lg:flex lg:flex-row grid grid-rows-2 grid-flow-col w-fit gap-x-15px gap-y-15px">
              {paymentFooterImages.map((item) => (
                <Image
                  src={item.filename_disk!}
                  width={45}
                  height={32}
                  alt={item.description!}
                  key={item.id}
                />
              ))}
            </div>
          </footer>
        )}
        <div className="mb-[4.375rem] md:mb-[7.5rem]"></div>
      </ContentWrapper>
    </section>
  );
};

export default CarDetailingPackageBlock;
